import React from "react";
import styles from './Checkbox.module.css'
import cx from "classnames";

type CheckboxProps = {
    property: string
    value: boolean
    label: React.ReactNode
    onChange: (property: string, value: boolean) => void
    classes?: string
    hierarchy?: 'default' | 'tree'
};

const Checkbox: React.FC<CheckboxProps> = ({ property, value, label, onChange, classes , hierarchy = 'default'}) => {
    let className;

    switch (hierarchy) {
        case "tree":
            className = cx(styles['zr-checkbox'], styles['zr-checkbox-tree'], classes);
            break;
        default:
            className = cx(styles['zr-checkbox'], classes);
            break;
    }

    return (
        <label className={className}>
            <input
                type="checkbox"
                checked={value}
                onChange={(e) => onChange(property, e.target.checked)}

            />
            <span className={cx(styles["checkmark"])}/>
            <span className={cx(styles["label-text"])}>{label}</span>
        </label>
    );
};

export default Checkbox;
